import { changePathSelectOperator as changePathSelectOperatorDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type PathSelectOperatorProps = {
    mode?: string;
}

export const changePathSelectOperator = ({
    mode,
}: PathSelectOperatorProps) => {
    changePathSelectOperatorDiagram({ mode });
};
